import type { BulkBidResult } from './useBulkBidding.types';

export const BULK_BIDDING_VIEW_NAMES = {
	CONFIRMATION: 'Confirmation',
	PROCESSING: 'Processing',
	RESULTS: 'Results',
} as const;

export type UseBulkBiddingViewName = (typeof BULK_BIDDING_VIEW_NAMES)[keyof typeof BULK_BIDDING_VIEW_NAMES];

interface UseBulkBiddingViewNameParams {
	bidResults?: BulkBidResult;
	isCreatingBids: boolean;
}

export const useBulkBiddingModalViewName = ({
	bidResults,
	isCreatingBids,
}: UseBulkBiddingViewNameParams): UseBulkBiddingViewName => {
	if (isCreatingBids) {
		return 'Processing';
	}

	if (bidResults) {
		return 'Results';
	}

	return 'Confirmation';
};
